import { searchTicket } from "@/api/customerTicket";
import { useLoadingStore } from "@/stores/loading";
import { useUserStore } from "@/stores/user";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams } from "react-router-dom";

interface Ticket {
  data_id: number;
  data_ticket_id: number;
  control_no: number;
  inquiry_type1: string;
  inquiry_type2: string;
  comment: string;
}

interface SearchParams {
  keyword: string | null;
}

export const TicketSearch = () => {
  const setLoading = useLoadingStore((state) => state.setLoading);
  const user = useUserStore((state) => state.user);
  const [keyword, setKeyword] = useState<string | null>(null);
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const { customerId } = useParams();
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<SearchParams>({
    reValidateMode: "onSubmit",
    defaultValues: {
      keyword: null,
    },
  });

  const onSubmit = (data: SearchParams) => {
    if (!user?.id) return;

    setLoading(true);
    searchTicket({ 
      keyword: data.keyword,
      customer_id: customerId ? parseInt(customerId) : undefined
    })
      .then((result) => {
        setTickets(result.data || []);
        setKeyword(data.keyword);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onClickReset = (e: any) => {
    e.preventDefault();
    reset();
    setTickets([]);
    setKeyword(null);
  };

  return (
    <div className="ticket-search-container">
      <form onSubmit={handleSubmit(onSubmit)}>
        <table className="condition-tbl">
          <tbody>
            <tr className="header">
              <td colSpan={4}>キーワード</td>
            </tr>
            <tr>
              <td colSpan={4}>
                <div className="uk-flex">
                  <input
                    className="uk-width-1-1"
                    {...register("keyword")}
                    placeholder="検索キーワードを入力"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="uk-flex uk-flex-center">
                  <button
                    className="uk-button--m uk-button-refer"
                    type="submit"
                  >
                    検索
                  </button>
                  <button
                    className="uk-button--m uk-button-cancel uk-margin-left"
                    onClick={(e) => onClickReset(e)}
                  >
                    クリア
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </form>

      <div className="ticket-search-result">
        {tickets?.map((ticket, index) => (
          <React.Fragment key={index}>
            <div className="ticket-search-result-item">
              <Link
                to={`/customer/ticket/${customerId}/${ticket.data_ticket_id}`}
              >
                {ticket.control_no}
              </Link>
              <div>問合せ区分1：{ticket.inquiry_type1}</div>
              <div>問合せ区分2：{ticket.inquiry_type2}</div>
              <div className="uk-margin-small-top">
                <HighlightKeywords text={ticket.comment} keyword={keyword} />
              </div>
            </div>
            <hr />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

type HighlightKeywordsProps = {
  text: string;
  keyword: string | null;
};

const HighlightKeywords: React.FC<HighlightKeywordsProps> = ({
  text,
  keyword,
}) => {
  const keywords = keyword ? keyword.split(/[\s  ]+/) : [];
  const escapeRegExp = (str: string) =>
    str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const keywordsRegex = new RegExp(keywords.map(escapeRegExp).join("|"), "gi");

  const parts = text.split(keywordsRegex);
  return (
    <>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {part}
          {index < parts.length - 1 && (
            <span className="uk-text-danger">
              {text.match(keywordsRegex)?.[index]}
            </span>
          )}
        </React.Fragment>
      ))}
    </>
  );
};
